module.exports = __webpack_public_path__ + "static/img/10007 (2).727ffa2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10007 (2).webp
// module id = LSOQ
// module chunks = 14